// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"273":"1e04b33bcffbc4cd","412":"f5a5c64c478b80e3"}[chunkId] + ".js";
};